'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwTreeViewNode = require('./CwTreeViewNode');

var _CwTreeViewNode2 = _interopRequireDefault(_CwTreeViewNode);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwTreeView = function CwTreeView(props) {

  var getItemCollapsed = function getItemCollapsed(item) {
    // isCollapsed flag defaults to true
    return item.isCollapsed === undefined ? true : item.isCollapsed;
  };

  var getUpdatedItems = function getUpdatedItems(item, selectedItem) {
    // recursively build updated children items
    var children = item.children ? item.children.map(function (child) {
      return getUpdatedItems(child, selectedItem);
    }) : undefined;

    var isSelectedItem = item.id === selectedItem.id; // use unique id to determine selection
    item.isSelected = isSelectedItem; // explicitly set for all items. selected item should be mutually exclusive
    item.isCollapsed = isSelectedItem ? !selectedItem.isCollapsed : getItemCollapsed(item); // only toggle for selected item, else use default
    item.children = children; // nested updated children items

    return item;
  };

  var handleClick = function handleClick(selectedItem) {
    // get updated treeview value with changes from selection
    var updatedItems = props.value.map(function (item) {
      return getUpdatedItems(item, selectedItem);
    });

    // fire onChange with full updated treeview value
    if (props.onChange) {
      props.onChange(updatedItems);
    }

    // fire onItemSelected with just selected id
    // to avoid consumer having to iterate through
    // full treeview value to find selected item
    if (props.onItemSelected) {
      props.onItemSelected(selectedItem.id);
    }
  };

  var getTreeViewNode = function getTreeViewNode(item) {
    // recursively build children treeviewnodes
    var children = item.children ? item.children.map(function (child) {
      return getTreeViewNode(child);
    }) : undefined;

    // create full value prop object for CwTreeViewNode
    var value = {
      id: item.id,
      name: item.name,
      isSelected: item.isSelected === undefined ? false : item.isSelected, // isSelected flag defaults to false
      isCollapsed: getItemCollapsed(item),
      children: children // nested CwTreeViewNode elements
    };

    return _react2.default.createElement(
      _CwTreeViewNode2.default,
      {
        key: value.id,
        cwId: props.cwId + '_node_' + value.id,
        collapseIcon: props.collapseIcon,
        expandIcon: props.expandIcon,
        value: value,
        onClick: handleClick },
      children
    );
  };

  // iterate through value prop and create treeviewnode elements
  var treeView = props.value.map(function (item) {
    return getTreeViewNode(item);
  });

  return _react2.default.createElement(
    'div',
    { 'data-cwid': props.cwId, style: props.style, className: props.className },
    treeView
  );
};

// recursive treeviewnode proptype shape
var nodeShape = (0, _assign2.default)({}, _CwTreeViewNode.treeViewNodeShape);
nodeShape.children = _propTypes2.default.arrayOf(_propTypes2.default.shape(nodeShape));

CwTreeView.propTypes = {
  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes2.default.string,
  /**
   * Collapse icon to display when expanded for treeviewnode with children
   */
  collapseIcon: _propTypes2.default.string,
  /**
   * Expand icon to display when collapsed for treeviewnode with children
   */
  expandIcon: _propTypes2.default.string,
  /**
   * Treeview layout data
   */
  value: _propTypes2.default.arrayOf(_propTypes2.default.shape(nodeShape)),
  /**
   * Fires entire updated value layout whenever an item is selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Fires selected id whenever an item is selected
   */
  onItemSelected: _propTypes2.default.func,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string
};

CwTreeView.defaultProps = {
  cwId: '',
  collapseIcon: _IconPath2.default.get('Action_Tree_Collapse'),
  expandIcon: _IconPath2.default.get('Action_Tree_Expand')
};

exports.default = CwTreeView;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtreeview/CwTreeView.js
// module id = 866
// module chunks = 10